import React, { Component } from 'react';

import { connect } from 'react-redux';

import { getCustomizationInfo } from '@/api/SystemApi';
import { setSystemInfo } from '@/store/actions/SystemActions';
import { loadAIChatBot } from '@/tool/AIChatBot';
import { setCustomSecret, resetCustomSecret } from '@/tool/crypto';
import {
  getCryptoType,
  setCaptcha,
  setCryptoType,
  setReportMailSupport,
  setMulti,
  getToken,
  setSiteTitle,
  getSiteTitle,
} from '@/tool/profile';
import { isDevEnv } from '@/tool/tool';

let customizationLoaded = false;

export const resetCustomizationLoaded = () => {
  customizationLoaded = false;
};

export default WrappedComponent => {
  class Container extends Component {
    constructor(props) {
      super(props);
      this.state = {};
    }

    componentDidMount() {
      // console.log('~~~~~~~~~~~~~~~~LayoutHOC~~~~~~~~~~~~~~~`');
      const { dispatch } = this.props;

      if (!customizationLoaded) {
        customizationLoaded = true;
        // 获取个性化信息并保存到store;
        getCustomizationInfo().then(
          data => {
            console.log('getCustomizationInfo', data);
            const info = { flag: data.flag };
            info.appLogo = data.logo;
            info.appName = data.name;
            info.appTitle = data.title;
            info.appProducer = data.producer;
            info.appUrl = data.url;
            info.keycabinetLogo = data.keycabinet_logo;
            info.keycabinetName = data.keycabinet_name;
            info.bititle = data.bititle;
            info.guest = data.guest;
            // 多企业标记
            info.multi = data.multi;
            // 是否支持系统用户通过邮件找回密码 0：不支持 1：支持
            info.mailenabled = data.mailenabled;

            info.customized = data.customized;
            info.captcha = data.captcha;
            info.reportMail = data.reportMail;
            info.edition = data.edition;

            const token = getToken();
            let siteTile = getSiteTitle();
            if (token || !siteTile) {
              siteTile = data.title;
              setSiteTitle(siteTile);
            }
            // 使用定制的网站title;
            document.title = siteTile;

            // 设置网站favicon;
            const link =
              document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = `${info.appLogo}?time=${new Date().getTime()}`;
            document.getElementsByTagName('head')[0].appendChild(link);
            dispatch(setSystemInfo(info));

            // 设置加密方式
            if (getCryptoType() != data.crypto) {
              setCryptoType(data.crypto || 0);
            }
            // 设置自定义加密密钥
            if (data.cryptoKey !== '') {
              setCustomSecret(data.cryptoKey);
            } else {
              resetCustomSecret();
            }

            // 设置是否多企业
            setMulti(data.multi);
            // 设置是否需要验证码
            setCaptcha(data.captcha);
            // 设置是否支持发邮件
            setReportMailSupport(data.reportMail);
          },
          () => {}
        );

        if (
          (isDevEnv() || /^(c|t|mt|qy)\.vanmalock\.com$/.test(window.location.hostname)) &&
          (navigator.language || navigator.browserLanguage).startsWith('zh')
        )
          loadAIChatBot();
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return connect(null)(Container);
};
